var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"header__favorites order-6",attrs:{"href":_vm.route}},[(_vm.list.length)?_c('span',{staticClass:"header__counter header__favorites-counter"},[_vm._v(_vm._s(_vm.list.length))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }